import React from 'react'
import classes from './Description.module.css'
import Image1 from '../../../Assests/Image/illlustration3.png'
const Description = ()=>{
    return(
        <div className={classes.item}>
        <div className={classes.Container}>
           
            <div className={classes.content}>
        <p className={classes.heading}>
       How Glossaread helps Students
       </p>
        <p className={classes.subHeading} >
        With Glossaread, you can now study anytime anywhere at your own pace. No need to rush for notes only when the exams are around the corner. Keep studying, exercising, polishing your skills and reaping the benefits of your efforts. 
            </p>
        <ul>
            <li className={classes.li}><p className={classes.list}>No need to juggle between different sources for notes</p></li>
            <li className={classes.li}><p className={classes.list}>No need to stand in lengthy queues at the photocopier</p></li>
            <li className={classes.li}><p className={classes.list}>With all your study material available online,<b>Study anytime anywhere</b></p></li>
            <li className={classes.li}><p className={classes.list}>Revision made easy with crisp notes on every subject</p></li>
            <li className={classes.li}><p className={classes.list}>Practice Question Banks/MCQs and polish your skills</p></li>
            <li className={classes.li}><p className={classes.list}>No need to buy an entire book, just <b>buy the chapters</b> you want</p></li>
        </ul>
        <button className={classes.btn}>Sign Up</button>
            </div>
            <div className={classes.illustration}>
            <img  className={classes.image}src={Image1} alt="alt"></img>
            </div>
            </div>
        </div>
    )
}
export default Description